import React, { useState, useRef, useEffect } from 'react';

// ============================================================
// DASHBOARD MARKETING — v3 filtres (19/09/2026)
// Nouveau : périodes année / multi-mois / plage de jours,
// filtre campagnes/canaux, tunnels empilés par sélection.
// Toutes les sections lisent l'API /api/marketing/dashboard :
// KPI + variations, performance par canal, tunnel, top campagnes,
// évolution jour/semaine/mois.
// Dépenses = Google Ads uniquement (Meta/TikTok non branchés).
// ============================================================

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MOIS_NOMS = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
const MOIS_COURTS = ['janv','fév','mars','avr','mai','juin','juil','août','sept','oct','nov','déc'];

// Canaux du filtre campagnes (clés = paramètres API)
const CANAUX_META = {
  google:    { nom: 'Google Ads', couleur: '#4285F4' },
  meta:      { nom: 'Meta Ads',   couleur: '#7A3CF0' },
  tiktok:    { nom: 'TikTok',     couleur: '#0F1E3D' },
  organique: { nom: 'Organique',  couleur: '#0E9F6E' },
  autre:     { nom: 'Autre',      couleur: '#64748B' },
};
const ORDRE_CANAUX = ['google', 'meta', 'tiktok', 'organique', 'autre'];
const canalVersCle = (nom) => (
  nom === 'Google Ads' ? 'google' : nom === 'Meta Ads' ? 'meta' :
  nom === 'TikTok' ? 'tiktok' : nom === 'Organique' ? 'organique' : 'autre');
const isoDate = (d) => d.toISOString().slice(0, 10);

// ------------------------------------------------------------
// CSS (scopé .dbmkt)
// ------------------------------------------------------------
const CSS = `
.dbmkt { --bg:#EDF1F7; --card:#FFFFFF; --txt:#0F1E3D; --txt2:#64748B; --line:#E8EDF4;
  --blue:#2563EB; --green:#10B981; --orange:#F97316; --violet:#8B5CF6;
  --shadow:0 1px 2px rgba(15,30,61,.04), 0 10px 30px rgba(15,30,61,.06);
  font-family:'Inter',-apple-system,sans-serif; color:var(--txt);
  display:flex; flex-direction:column; gap:14px; -webkit-font-smoothing:antialiased; }
.dbmkt * { box-sizing:border-box; }
.dbmkt .card { background:var(--card); border-radius:16px; box-shadow:var(--shadow); }
.dbmkt .filtres { display:flex; justify-content:flex-end; align-items:center; gap:14px; position:relative; margin-top:14px; }
.dbmkt .btn { font-family:inherit; font-size:13px; font-weight:600; color:var(--txt);
  background:#F1F5FB; border:1px solid var(--line); border-radius:10px; padding:9px 15px; cursor:pointer; }
.dbmkt .btn:hover { background:#E7EEF8; }
.dbmkt .btn.periode { display:flex; align-items:center; gap:8px; background:#fff; }
.dbmkt .picker { position:absolute; top:44px; right:0; z-index:20; background:#fff; border-radius:14px;
  box-shadow:0 8px 30px rgba(15,30,61,.18); padding:12px; width:270px; }
.dbmkt .picker .onglets { display:flex; gap:6px; margin-bottom:10px; }
.dbmkt .picker .onglets button { flex:1; font-family:inherit; border:none; background:#F1F5FB; color:var(--txt2);
  font-size:12px; font-weight:700; border-radius:8px; padding:7px 0; cursor:pointer; }
.dbmkt .picker .onglets button.on { background:var(--blue); color:#fff; }
.dbmkt .picker .annees { display:grid; gap:6px; }
.dbmkt .picker .annees button { font-family:inherit; border:none; background:#F6F8FC; border-radius:8px;
  padding:9px 0; font-size:13px; font-weight:700; color:var(--txt); cursor:pointer; }
.dbmkt .picker .annees button:hover { background:#E7EEF8; }
.dbmkt .picker .annees button.on { background:var(--blue); color:#fff; }
.dbmkt .picker .dates { display:grid; gap:8px; }
.dbmkt .picker .dates label { font-size:11px; font-weight:700; color:var(--txt2); display:block; margin-bottom:3px; }
.dbmkt .picker .dates input { width:100%; font-family:inherit; font-size:13px; padding:8px;
  border:1px solid var(--line); border-radius:8px; color:var(--txt); background:#fff; }
.dbmkt .picker .aide { font-size:11px; font-weight:500; color:var(--txt2); margin-top:8px; }
.dbmkt .camps { position:absolute; top:44px; right:0; z-index:20; background:#fff; border-radius:14px;
  box-shadow:0 8px 30px rgba(15,30,61,.18); padding:8px; width:330px; max-height:360px; overflow-y:auto; }
.dbmkt .camps label.ligne { display:flex; align-items:center; gap:9px; padding:7px 9px; border-radius:8px;
  cursor:pointer; font-size:12.5px; font-weight:600; }
.dbmkt .camps label.ligne:hover { background:#F6F8FC; }
.dbmkt .camps input { accent-color:var(--blue); width:15px; height:15px; flex:none; margin:0; }
.dbmkt .camps .nomc { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.dbmkt .camps .toutes { font-weight:800; }
.dbmkt .camps .canal-t { font-weight:800; }
.dbmkt .camps .enfant { padding-left:32px; color:var(--txt2); font-weight:500; }
.dbmkt .camps .sep { height:1px; background:var(--line); margin:5px 2px; }
.dbmkt .pointc { width:9px; height:9px; border-radius:50%; flex:none; }
.dbmkt .tunnel-bloc { border:1px solid var(--line); border-radius:14px; padding:13px 14px; margin-bottom:12px; }
.dbmkt .tunnel-bloc:last-child { margin-bottom:0; }
.dbmkt .tunnel-head { display:flex; align-items:center; gap:9px; margin-bottom:11px; }
.dbmkt .tunnel-head .titre-t { font-size:13px; font-weight:700; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.dbmkt .tunnel-head .dep-t { margin-left:auto; font-size:12px; font-weight:700; color:var(--txt2); white-space:nowrap; }
.dbmkt .badge-canal { display:inline-flex; align-items:center; gap:5px; font-size:10.5px; font-weight:800;
  border-radius:7px; padding:3px 8px; color:#fff; flex:none; }
.dbmkt .picker .an { display:flex; align-items:center; justify-content:space-between; margin-bottom:10px; }
.dbmkt .picker .an b { font-size:14px; }
.dbmkt .picker .an button { border:none; background:#F1F5FB; border-radius:8px; width:26px; height:26px;
  cursor:pointer; font-weight:700; color:var(--txt2); }
.dbmkt .picker .grille { display:grid; grid-template-columns:repeat(3,1fr); gap:6px; }
.dbmkt .picker .grille button { font-family:inherit; border:none; background:#F6F8FC; border-radius:8px;
  padding:8px 0; font-size:12px; font-weight:600; color:var(--txt); cursor:pointer; }
.dbmkt .picker .grille button:hover { background:#E7EEF8; }
.dbmkt .picker .grille button.on { background:var(--blue); color:#fff; }
.dbmkt .kpis { display:grid; grid-template-columns:repeat(6,1fr); gap:14px; }
.dbmkt .kpi { padding:9px 14px 0; overflow:hidden; display:flex; flex-direction:column; }
.dbmkt .kpi .top { display:flex; align-items:center; gap:7px; }
.dbmkt .kpi .ico { width:26px; height:26px; border-radius:8px; display:flex; align-items:center; justify-content:center; flex:none; }
.dbmkt .kpi .name { font-size:12px; font-weight:600; color:var(--txt2); white-space:nowrap; }
.dbmkt .kpi .row2 { display:flex; align-items:center; justify-content:space-between; gap:6px; margin-top:4px; }
.dbmkt .kpi .val { font-size:19px; font-weight:800; letter-spacing:-.6px; white-space:nowrap; }
.dbmkt .kpi .val small { font-size:11px; font-weight:600; color:var(--txt2); letter-spacing:0; }
.dbmkt .badge { display:inline-flex; align-items:center; gap:4px; white-space:nowrap; flex:none;
  font-size:11px; font-weight:700; color:#0E9F6E; background:#E5F8F0; border-radius:8px; padding:3px 7px; }
.dbmkt .badge svg { width:8px; height:8px; }
.dbmkt .badge.rouge { color:#DC2626; background:#FDEBEB; }
.dbmkt .badge.rouge svg path { fill:#DC2626; }
.dbmkt .badge .tri-bas { transform:rotate(180deg); }
.dbmkt .kpi .extra { font-size:11px; font-weight:600; color:var(--txt2); margin-top:3px; white-space:nowrap; }
.dbmkt .kpi .spark { margin-top:auto; display:block; width:100%; height:20px; }
.dbmkt .jauge { margin-top:5px; }
.dbmkt .jauge .piste { height:6px; border-radius:99px; background:#E5EBF4; overflow:hidden; }
.dbmkt .jauge .rempli { height:100%; border-radius:99px; background:linear-gradient(90deg,#2563EB,#3B82F6); }
.dbmkt .section { padding:16px 20px 18px; }
.dbmkt .sec-head { display:flex; align-items:center; gap:10px; margin-bottom:12px; }
.dbmkt .sec-head .ico { width:30px; height:30px; border-radius:9px; display:flex; align-items:center; justify-content:center; }
.dbmkt .sec-head h2 { font-size:15.5px; font-weight:700; letter-spacing:-.2px; margin:0; }
.dbmkt .sec-head .spacer { flex:1; }
.dbmkt .sec-head .tag { font-size:12px; font-weight:600; color:var(--txt2); }
.dbmkt table { width:100%; border-collapse:collapse; }
.dbmkt thead th { font-size:11.5px; font-weight:600; color:var(--txt2); text-align:right; background:#F6F8FC; padding:9px 12px; }
.dbmkt thead th:first-child { text-align:left; border-radius:9px 0 0 9px; }
.dbmkt thead th:last-child { border-radius:0 9px 9px 0; }
.dbmkt tbody td { font-size:13px; font-weight:600; padding:11px 12px; text-align:right; border-bottom:1px solid var(--line); }
.dbmkt tbody td:first-child { text-align:left; }
.dbmkt tbody tr:last-child td { border-bottom:none; }
.dbmkt td .canal { display:flex; align-items:center; gap:9px; font-weight:600; }
.dbmkt td .canal .ci { width:22px; height:22px; border-radius:7px; display:flex; align-items:center; justify-content:center; flex:none; }
.dbmkt .muted { color:#9AA7BD; }
.dbmkt tr.total td { background:#F6F8FC; font-weight:800; border-bottom:none; }
.dbmkt tr.total td:first-child { border-radius:9px 0 0 9px; }
.dbmkt tr.total td:last-child { border-radius:0 9px 9px 0; }
.dbmkt .vide { text-align:center; color:var(--txt2); font-size:13px; font-weight:500; padding:18px 0; }
.dbmkt .tunnel { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
.dbmkt .etape { flex:1; min-width:150px; display:flex; align-items:center; gap:11px; border-radius:13px; padding:13px 15px; }
.dbmkt .etape .ei { width:34px; height:34px; border-radius:10px; background:#fff; display:flex; align-items:center; justify-content:center; flex:none; }
.dbmkt .etape .lbl { font-size:12px; font-weight:600; }
.dbmkt .etape .num { font-size:20px; font-weight:800; letter-spacing:-.5px; margin-top:1px; }
.dbmkt .fleche { display:flex; flex-direction:column; align-items:center; gap:2px; color:var(--txt2); flex:none; }
.dbmkt .fleche .pct { font-size:11.5px; font-weight:700; }
.dbmkt .tunnel .sep { width:1px; align-self:stretch; background:var(--line); margin:0 6px; }
.dbmkt .global { display:flex; align-items:center; gap:12px; padding:0 8px; }
.dbmkt .global .txt1 { font-size:12px; font-weight:600; color:var(--txt2); }
.dbmkt .global .txt2 { font-size:21px; font-weight:800; letter-spacing:-.5px; }
.dbmkt .global .txt3 { font-size:11.5px; color:var(--txt2); font-weight:500; }
.dbmkt .evo-controls { display:flex; align-items:center; gap:9px; flex-wrap:wrap; margin-bottom:10px; }
.dbmkt .chk { display:inline-flex; align-items:center; gap:7px; cursor:pointer; user-select:none;
  font-size:12.5px; font-weight:600; padding:7px 12px; border-radius:10px; border:1px solid var(--line); background:#fff; }
.dbmkt .chk .box { width:16px; height:16px; border-radius:5px; display:flex; align-items:center; justify-content:center; color:#fff; }
.dbmkt .chk .box svg { width:10px; height:10px; }
.dbmkt .chk.off { opacity:.45; }
.dbmkt .chk.off .box { background:#CBD5E1 !important; }
.dbmkt .evo-vues { margin-left:auto; display:flex; background:#F1F5FB; border:1px solid var(--line); border-radius:10px; padding:3px; }
.dbmkt .evo-vues button { font-family:inherit; font-size:12.5px; font-weight:600; color:var(--txt2);
  background:none; border:none; border-radius:8px; padding:6px 14px; cursor:pointer; }
.dbmkt .evo-vues button.on { background:#fff; color:var(--blue); box-shadow:0 1px 3px rgba(15,30,61,.10); }
.dbmkt .evo-wrap { position:relative; }
.dbmkt .evo-tip { position:absolute; pointer-events:none; z-index:5; background:#fff; border-radius:12px;
  box-shadow:0 6px 24px rgba(15,30,61,.16); padding:10px 13px; font-size:12px; min-width:170px; top:16px; }
.dbmkt .evo-tip .d { font-weight:800; font-size:12.5px; margin-bottom:6px; }
.dbmkt .evo-tip .l { display:flex; align-items:center; gap:7px; margin-top:3px; font-weight:500; color:var(--txt2); }
.dbmkt .evo-tip .l b { margin-left:auto; color:var(--txt); font-weight:700; }
.dbmkt .evo-tip .pt { width:8px; height:8px; border-radius:50%; flex:none; }
@media (max-width:1100px){ .dbmkt .kpis { grid-template-columns:repeat(3,1fr); } }
@media (max-width:700px){ .dbmkt .kpis { grid-template-columns:repeat(2,1fr); }
  .dbmkt .tunnel .sep { display:none; } .dbmkt .section { overflow-x:auto; } }
`;

// ------------------------------------------------------------
// Formatage
// ------------------------------------------------------------
const fmtEuro = (n) => (n == null ? '—' : Math.round(n).toLocaleString('fr-FR') + ' €');
const fmtNum = (n) => (n == null ? '—' : n.toLocaleString('fr-FR'));
const fmtRoas = (n) => (n == null ? '—' : String(n).replace('.', ',') + 'x');
const fmtRoasTab = (n) => (n == null ? '—' : String(n).replace('.', ','));
const fmtPct = (n) => (n == null ? '—' : String(n).replace('.', ',') + ' %');
const dateFr = (iso) => { // '2026-05-15' -> {j:15, m:4, a:2026}
  const [a, m, j] = iso.split('-').map(Number);
  return { j, m: m - 1, a };
};

// Générateur pseudo-aléatoire déterministe (sparklines décoratives)
function rnd(seed) { let s = seed; return () => { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; }; }

const EVO_SERIES = [
  { key: 'leads',    label: 'Leads',             color: '#3B82F6', axis: 'g', euro: false },
  { key: 'depenses', label: 'Dépenses',          color: '#60A5FA', axis: 'd', euro: true },
  { key: 'cpl',      label: 'CPL',               color: '#8B5CF6', axis: 'd', euro: true },
  { key: 'installs', label: 'Clients installés', color: '#F97316', axis: 'g', euro: false },
  { key: 'ca',       label: 'CA généré',         color: '#10B981', axis: 'd', euro: true },
];

// Sens "favorable" des variations : coûts = baisse verte, volume = hausse verte
const DELTA_BON_EN_HAUSSE = { depenses: false, leads: true, cpl: false, installs: true, cac: false, ca: true };

// ------------------------------------------------------------
// Icônes
// ------------------------------------------------------------
const IcoCarte = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="3"/><path d="M2 10h20"/></svg>);
const IcoUsers = ({ c = '#2563EB', s = 16 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2"><circle cx="9" cy="8" r="3.2"/><path d="M3.5 19c.6-3 2.8-4.5 5.5-4.5s4.9 1.5 5.5 4.5"/><circle cx="17" cy="8" r="2.6"/><path d="M16 14.6c2.3.2 4 1.6 4.5 4"/></svg>);
const IcoLosange = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2"><rect x="4.5" y="4.5" width="15" height="15" rx="3" transform="rotate(45 12 12)"/></svg>);
const IcoCible = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5.2"/><circle cx="12" cy="12" r="1.6" fill="#7C3AED"/></svg>);
const IcoBarres = ({ s = 16 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="none"><rect x="3" y="12" width="4" height="8" rx="1.5" fill="#2563EB"/><rect x="10" y="7" width="4" height="13" rx="1.5" fill="#3B82F6"/><rect x="17" y="3" width="4" height="17" rx="1.5" fill="#60A5FA"/></svg>);
const IcoEntonnoir = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2"><path d="M3 4h18l-7 8v6l-4 2v-8L3 4z"/></svg>);
const IcoTrophee = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2"><path d="M7 3h10v5a5 5 0 0 1-10 0V3z"/><path d="M7 5H4a3 3 0 0 0 3 4M17 5h3a3 3 0 0 1-3 4M12 13v4m-4 4h8m-4-4v4"/></svg>);
const IcoCourbe = ({ s = 15, c = '#2563EB' }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2"><path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/></svg>);
const IcoDoc = ({ c }) => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2"><path d="M6 2h9l4 4v16H6z"/><path d="M14 2v5h5M9 12h7M9 16h7"/></svg>);
const IcoDocOk = ({ c }) => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2"><path d="M6 2h9l4 4v16H6z"/><path d="M14 2v5h5M9 15l2.2 2.2L15.5 13"/></svg>);
const IcoCal = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2"><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M8 3v4M16 3v4M3 10h18"/></svg>);
const IcoChevron = () => (<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.5"><path d="M6 9l6 6 6-6"/></svg>);
const IcoFleche = () => (<svg width="20" height="14" viewBox="0 0 24 14" fill="none" stroke="#64748B" strokeWidth="2"><path d="M1 7h19M15 2l6 5-6 5"/></svg>);
const Tri = ({ bas }) => (<svg viewBox="0 0 10 10" fill="#0E9F6E" className={bas ? 'tri-bas' : ''}><path d="M5 0l5 8H0z"/></svg>);
const Coche = () => (<svg viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2.4"><path d="M2 6.5l2.6 2.6L10 3.5"/></svg>);

const LogoGoogle = () => (<svg width="13" height="13" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.5 12.2c0-.8-.07-1.5-.2-2.2H12v4.3h5.9a5 5 0 0 1-2.2 3.3v2.7h3.5c2.1-1.9 3.3-4.7 3.3-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-1 7.28-2.7l-3.5-2.7c-1 .65-2.2 1.05-3.78 1.05-2.9 0-5.36-1.96-6.24-4.6H2.1v2.85A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.76 14.05a6.6 6.6 0 0 1 0-4.2V7H2.1a11 11 0 0 0 0 9.9l3.66-2.85z"/><path fill="#EA4335" d="M12 5.35c1.62 0 3.06.56 4.2 1.65l3.1-3.1C17.45 2.1 14.97 1 12 1A11 11 0 0 0 2.1 7l3.66 2.85C6.64 7.3 9.1 5.35 12 5.35z"/></svg>);
const LogoMeta = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0866FF" strokeWidth="2.6"><path d="M2.5 15.5c0-4 1.8-8 4.6-8 2.2 0 3.4 2.3 4.9 5.3 1.5-3 2.7-5.3 4.9-5.3 2.8 0 4.6 4 4.6 8"/><path d="M2.5 15.5c0 .9.7 1.6 1.6 1.6 2 0 3.2-2.2 4.6-5m12.8 3.4c0 .9-.7 1.6-1.6 1.6-2 0-3.2-2.2-4.6-5"/></svg>);
const LogoTikTok = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="#fff"><path d="M16.6 2h3a6.9 6.9 0 0 0 2.4 4.3 7 7 0 0 0 2 1.1v3.4a10.3 10.3 0 0 1-4.5-1.4v6.8A7.6 7.6 0 1 1 12 8.7c.4 0 .8 0 1.2.1v3.5a4.1 4.1 0 1 0 3.4 4V2z" transform="scale(0.86) translate(1.5,1.5)"/></svg>);
const LogoAutre = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="#64748B"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>);

const CanalLogo = ({ nom }) => {
  if (nom === 'Google Ads') return <span className="ci" style={{ background: '#F1F5FB' }}><LogoGoogle /></span>;
  if (nom === 'Meta Ads') return <span className="ci" style={{ background: '#EAF1FF' }}><LogoMeta /></span>;
  if (nom === 'TikTok') return <span className="ci" style={{ background: '#0F1E3D' }}><LogoTikTok /></span>;
  return <span className="ci" style={{ background: '#F1F5FB' }}><LogoAutre /></span>;
};

// ------------------------------------------------------------
// Badge de variation vs période précédente
// ------------------------------------------------------------
const DeltaBadge = ({ pct, metric }) => {
  if (pct == null) return null;
  const hausse = pct >= 0;
  const bon = DELTA_BON_EN_HAUSSE[metric] ? hausse : !hausse;
  return (
    <span className={'badge' + (bon ? '' : ' rouge')}>
      <Tri bas={!hausse} />{String(Math.abs(pct)).replace('.', ',')} %
    </span>
  );
};

// ------------------------------------------------------------
// Sparkline décorative (visuel maquette)
// ------------------------------------------------------------
const Spark = ({ color, seed }) => {
  const W = 200, H = 24, n = 14;
  const r = rnd(seed * 97 + 13);
  const pts = [];
  for (let i = 0; i < n; i++) { pts.push([i / (n - 1) * W, H - 4 - (r() * 0.5 + 0.25 + i / n * 0.25) * (H - 8)]); }
  const d = 'M' + pts.map(p => p[0].toFixed(1) + ',' + p[1].toFixed(1)).join(' L');
  const gid = 'dbmkt_g' + seed;
  return (
    <svg className="spark" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
      <defs><linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor={color} stopOpacity=".28" /><stop offset="1" stopColor={color} stopOpacity="0" />
      </linearGradient></defs>
      <path d={`${d} L${W},${H} L0,${H} Z`} fill={`url(#${gid})`} />
      <path d={d} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

const KpiCard = ({ ico, icoBg, name, val, valSuffix, deltaPct, metric, extra, jauge, sparkColor, sparkSeed }) => (
  <div className="card kpi">
    <div className="top"><span className="ico" style={{ background: icoBg }}>{ico}</span><span className="name">{name}</span></div>
    <div className="row2">
      <span className="val">{val}{valSuffix ? <small> {valSuffix}</small> : null}</span>
      <DeltaBadge pct={deltaPct} metric={metric} />
    </div>
    {jauge != null && (
      <div className="jauge"><div className="piste"><div className="rempli" style={{ width: jauge + '%' }} /></div></div>
    )}
    {extra ? <div className="extra">{extra}</div> : null}
    <Spark color={sparkColor} seed={sparkSeed} />
  </div>
);

// ------------------------------------------------------------
// Agrégation de l'évolution : jour brut, semaine (paquets de 7), mois
// ------------------------------------------------------------
function agregerEvolution(evolution, vue) {
  if (!evolution || evolution.length === 0) return [];
  const points = evolution.map(p => {
    const d = dateFr(p.date);
    return { ...p, label: `${d.j} ${MOIS_COURTS[d.m]}`, labelLong: `${d.j} ${MOIS_COURTS[d.m]} ${d.a}` };
  });
  if (vue === 'jour') return points;

  const groupes = [];
  if (vue === 'semaine') {
    for (let i = 0; i < points.length; i += 7) groupes.push(points.slice(i, i + 7));
  } else { // mois
    const parMois = {};
    points.forEach(p => {
      const cle = p.date.slice(0, 7);
      (parMois[cle] = parMois[cle] || []).push(p);
    });
    Object.keys(parMois).sort().forEach(k => groupes.push(parMois[k]));
  }
  return groupes.map(g => {
    const somme = (k) => g.reduce((a, p) => a + (p[k] || 0), 0);
    const leads = somme('leads'), dep = Math.round(somme('depenses') * 100) / 100;
    const prem = dateFr(g[0].date);
    return {
      date: g[0].date,
      leads,
      installs: somme('installs'),
      ca: Math.round(somme('ca') * 100) / 100,
      depenses: dep,
      cpl: leads > 0 && dep > 0 ? Math.round(dep / leads * 100) / 100 : null,
      label: vue === 'semaine' ? `${prem.j} ${MOIS_COURTS[prem.m]}` : `${MOIS_COURTS[prem.m]} ${prem.a}`,
      labelLong: vue === 'semaine' ? `Semaine du ${prem.j} ${MOIS_COURTS[prem.m]} ${prem.a}` : `${MOIS_NOMS[prem.m]} ${prem.a}`,
    };
  });
}

function borneHaute(max) {
  if (max <= 0) return 10;
  const puiss = Math.pow(10, Math.floor(Math.log10(max)));
  for (const m of [1, 2, 2.5, 5, 10]) { if (max <= m * puiss) return m * puiss; }
  return 10 * puiss;
}

// ------------------------------------------------------------
// Graphique Évolution (données réelles, multi-courbes, infobulle)
// ------------------------------------------------------------
const EvolutionChart = ({ points, actives }) => {
  const wrapRef = useRef(null);
  const [hover, setHover] = useState(null);
  const [largeur, setLargeur] = useState(1200);

  useEffect(() => {
    const mesurer = () => { if (wrapRef.current) setLargeur(wrapRef.current.clientWidth || 1200); };
    mesurer();
    window.addEventListener('resize', mesurer);
    return () => window.removeEventListener('resize', mesurer);
  }, []);

  const n = points.length;
  if (n === 0) return <div className="vide">Aucune donnée sur cette période</div>;

  const W = largeur, H = 240, P = { l: 42, r: 62, t: 10, b: 26 };
  const iw = W - P.l - P.r, ih = H - P.t - P.b;

  const maxG = borneHaute(Math.max(1, ...points.map(p => Math.max(p.leads || 0, p.installs || 0))));
  const maxD = borneHaute(Math.max(1, ...points.map(p => Math.max(p.depenses || 0, p.cpl || 0, p.ca || 0))));

  const x = i => (n === 1 ? P.l + iw / 2 : P.l + i / (n - 1) * iw);
  const yG = v => P.t + ih - (v / maxG) * ih;
  const yD = v => P.t + ih - (v / maxD) * ih;
  const fmtE = v => v.toLocaleString('fr-FR') + ' €';

  const onMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const px = e.clientX - rect.left;
    let i = n === 1 ? 0 : Math.round((px - P.l) / iw * (n - 1));
    setHover(Math.max(0, Math.min(n - 1, i)));
  };

  const gTicks = [0, 0.25, 0.5, 0.75, 1].map(f => Math.round(maxG * f));
  const dTicks = [0, 0.25, 0.5, 0.75, 1].map(f => Math.round(maxD * f));
  const visibles = EVO_SERIES.filter(s => actives[s.key]);
  const pasLabel = Math.max(1, Math.ceil(n / 16));

  let tipLeft = 0;
  if (hover != null) {
    tipLeft = x(hover) + 14;
    if (tipLeft + 190 > W) tipLeft -= 220;
  }

  return (
    <div className="evo-wrap" ref={wrapRef}>
      <svg width="100%" height="240" viewBox={`0 0 ${W} ${H}`} onMouseMove={onMove} onMouseLeave={() => setHover(null)}>
        {gTicks.map(v => (
          <g key={'g' + v}>
            <line x1={P.l} y1={yG(v)} x2={W - P.r} y2={yG(v)} stroke="#EDF1F7" />
            <text x={P.l - 8} y={yG(v) + 4} fontSize="10" fontWeight="600" fill="#94A3B8" textAnchor="end">{v.toLocaleString('fr-FR')}</text>
          </g>
        ))}
        {dTicks.map(v => (
          <text key={'d' + v} x={W - P.r + 8} y={yD(v) + 4} fontSize="10" fontWeight="600" fill="#94A3B8">{v ? v.toLocaleString('fr-FR') + ' €' : '0 €'}</text>
        ))}
        {points.map((p, i) => (i % pasLabel === 0 ? (
          <text key={'x' + i} x={x(i)} y={H - 8} fontSize="10" fontWeight="600" fill="#94A3B8" textAnchor="middle">{p.label}</text>
        ) : null))}
        {visibles.map(s => {
          const y = s.axis === 'g' ? yG : yD;
          const val = p => (p[s.key] == null ? 0 : p[s.key]);
          const d = 'M' + points.map((p, i) => `${x(i).toFixed(1)},${y(val(p)).toFixed(1)}`).join(' L');
          return (
            <g key={s.key}>
              {n > 1 && <path d={d} fill="none" stroke={s.color} strokeWidth="2" />}
              {points.map((p, i) => <circle key={i} cx={x(i)} cy={y(val(p))} r="3" fill={s.color} />)}
            </g>
          );
        })}
        {hover != null && (
          <line x1={x(hover)} y1={P.t} x2={x(hover)} y2={H - P.b} stroke="#94A3B8" strokeDasharray="3 3" />
        )}
      </svg>
      {hover != null && (
        <div className="evo-tip" style={{ left: tipLeft, display: 'block' }}>
          <div className="d">{points[hover].labelLong}</div>
          {visibles.map(s => (
            <div className="l" key={s.key}>
              <span className="pt" style={{ background: s.color }} />{s.label}
              <b>{points[hover][s.key] == null ? '—' : (s.euro ? fmtE(points[hover][s.key]) : points[hover][s.key])}</b>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ------------------------------------------------------------
// Ligne de tunnel (étapes horizontales) — réutilisée par les tunnels filtrés
// ------------------------------------------------------------
const TunnelLigne = ({ leads, devis_envoyes, devis_signes, installs, p1, p2, p3, taux_global, ch }) => (
  <div className="tunnel">
    <div className="etape" style={{ background: '#EAF1FD' }}>
      <span className="ei"><IcoUsers s={17} /></span>
      <div><div className="lbl" style={{ color: '#2563EB' }}>Leads</div><div className="num">{fmtNum(leads)}</div></div>
    </div>
    <div className="fleche"><span className="pct">{fmtPct(p1)}</span><IcoFleche /></div>
    <div className="etape" style={{ background: '#F2EDFD' }}>
      <span className="ei"><IcoDoc c="#7C3AED" /></span>
      <div><div className="lbl" style={{ color: '#7C3AED' }}>Devis envoyés</div><div className="num">{fmtNum(devis_envoyes)}</div></div>
    </div>
    <div className="fleche"><span className="pct">{fmtPct(p2)}</span><IcoFleche /></div>
    <div className="etape" style={{ background: '#E5F8EE' }}>
      <span className="ei"><IcoDocOk c="#10B981" /></span>
      <div><div className="lbl" style={{ color: '#0E9F6E' }}>Devis signés</div><div className="num">{fmtNum(devis_signes)}</div></div>
    </div>
    <div className="fleche"><span className="pct">{fmtPct(p3)}</span><IcoFleche /></div>
    <div className="etape" style={{ background: '#FDEFE3' }}>
      <span className="ei"><IcoUsers c="#F97316" s={17} /></span>
      <div><div className="lbl" style={{ color: '#F97316' }}>Clients installés</div><div className="num">{fmtNum(installs)}</div></div>
    </div>
    <div className="sep" />
    <div className="global">
      <IcoCourbe s={26} />
      <div>
        <div className="txt1">Taux d'installation</div>
        <div className="txt2">{fmtPct(taux_global)}</div>
        <div className="txt3">{`(${fmtNum(installs)} / ${fmtNum(leads)} leads)`}</div>
      </div>
    </div>
  </div>
);

// ------------------------------------------------------------
// Composant principal
// ------------------------------------------------------------
const DashboardMarketing = () => {
  const now = new Date();
  const [mode, setMode] = useState('mois'); // 'jour' | 'mois' | 'multimois' | 'annee' | 'plage'
  const [sel, setSel] = useState({ year: now.getFullYear(), month: now.getMonth(), day: now.getDate() });
  const [moisSel, setMoisSel] = useState([now.getMonth()]);
  const [plage, setPlage] = useState({ debut: isoDate(now), fin: isoDate(now) });
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pickerTab, setPickerTab] = useState('mois'); // 'annee' | 'mois' | 'jours'
  const [pickYear, setPickYear] = useState(now.getFullYear());
  const pickerRef = useRef(null);

  const [campOpen, setCampOpen] = useState(false);
  const [listeCamps, setListeCamps] = useState([]);
  const [selCanaux, setSelCanaux] = useState(() => {
    try { return JSON.parse(localStorage.getItem('dbmkt_canaux')) || []; } catch (e) { return []; }
  }); // clés canal cochées, mémorisées
  const [selCamps, setSelCamps] = useState(() => {
    try { return JSON.parse(localStorage.getItem('dbmkt_camps')) || []; } catch (e) { return []; }
  });   // ids campagne cochés, mémorisés

  // Mémoriser la sélection à chaque changement
  useEffect(() => {
    try {
      localStorage.setItem('dbmkt_canaux', JSON.stringify(selCanaux));
      localStorage.setItem('dbmkt_camps', JSON.stringify(selCamps));
    } catch (e) { /* stockage indisponible, pas bloquant */ }
  }, [selCanaux.join(','), selCamps.join(',')]);

  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erreur, setErreur] = useState(false);

  const [actives, setActives] = useState({ leads: true, depenses: true, cpl: true, installs: true, ca: true });
  const [vueEvo, setVueEvo] = useState('jour');

  useEffect(() => {
    const h = (e) => { if (pickerRef.current && !pickerRef.current.contains(e.target)) { setPickerOpen(false); setCampOpen(false); } };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setErreur(false);
      try {
        const token = localStorage.getItem('token');
        const params = new URLSearchParams();
        if (mode === 'jour') {
          params.set('periode', 'jour');
          params.set('year', sel.year);
          params.set('month', sel.month + 1);
          params.set('day', sel.day);
        } else if (mode === 'annee') {
          params.set('periode', 'annee');
          params.set('year', sel.year);
        } else if (mode === 'multimois') {
          params.set('periode', 'multimois');
          params.set('year', sel.year);
          params.set('months', moisSel.map(m => m + 1).join(','));
        } else if (mode === 'plage') {
          params.set('periode', 'plage');
          params.set('date_debut', plage.debut);
          params.set('date_fin', plage.fin);
        } else {
          params.set('periode', 'mois');
          params.set('year', sel.year);
          params.set('month', sel.month + 1);
        }
        if (selCanaux.length > 0) params.set('canaux', selCanaux.join(','));
        if (selCamps.length > 0) params.set('campagnes', selCamps.join(','));
        const response = await fetch(`${BACKEND_URL}/api/marketing/dashboard?${params.toString()}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const json = await response.json();
        if (json && json.data) setApiData(json.data);
        else { setApiData(null); setErreur(true); }
      } catch (err) {
        setApiData(null);
        setErreur(true);
      }
      setLoading(false);
    };
    fetchData();
  }, [mode, sel.year, sel.month, sel.day, moisSel.join(','), plage.debut, plage.fin, selCanaux.join(','), selCamps.join(',')]);

  // Liste des campagnes pour le menu (une fois au montage)
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const r = await fetch(`${BACKEND_URL}/api/marketing/campagnes`, { headers: { Authorization: `Bearer ${token}` } });
        const j = await r.json();
        const brut = (j && j.data && j.data.campagnes) || [];
        setListeCamps(brut
          .filter(c => c.id_campagne)
          .map(c => ({ id: String(c.id_campagne), nom: c.nom_google || c.nom, canal: canalVersCle(c.canal), leads: c.leads || 0 }))
          .sort((a, b) => b.leads - a.leads));
      } catch (e) { /* menu vide, pas bloquant */ }
    })();
  }, []);

  const d = apiData;
  const kpi = d ? d.kpi : null;
  const deltas = kpi && kpi.deltas ? kpi.deltas : {};
  const budgetMensuel = d && d.budget ? d.budget.mensuel : null;

  const frCourt = (iso) => { const [a, m, j] = iso.split('-'); return `${j}/${m}`; };
  const labelPeriode =
    mode === 'jour' ? `${sel.day} ${MOIS_COURTS[sel.month]} ${sel.year}`
    : mode === 'annee' ? `Année ${sel.year}`
    : mode === 'multimois' ? (moisSel.length <= 3
        ? moisSel.map(m => MOIS_COURTS[m]).join(', ') + ' ' + sel.year
        : `${moisSel.length} mois · ${sel.year}`)
    : mode === 'plage' ? `${frCourt(plage.debut)} → ${frCourt(plage.fin)}/${plage.fin.slice(0, 4)}`
    : `${MOIS_NOMS[sel.month]} ${sel.year}`;
  const tagPeriode = mode === 'mois' ? `${MOIS_NOMS[sel.month].slice(0, 3)} ${sel.year}` : labelPeriode;

  const toggleMois = (m) => {
    if ((mode !== 'mois' && mode !== 'multimois') || sel.year !== pickYear) {
      setMode('mois'); setSel({ year: pickYear, month: m, day: 1 }); setMoisSel([m]);
      return;
    }
    let s = moisSel.includes(m) ? moisSel.filter(x => x !== m) : [...moisSel, m].sort((a, b) => a - b);
    if (s.length === 0) s = [m];
    setMoisSel(s);
    setSel({ ...sel, month: s[0], day: 1 });
    setMode(s.length === 1 ? 'mois' : 'multimois');
  };
  const choisirAnnee = (a) => { setMode('annee'); setSel({ ...sel, year: a, day: 1 }); setPickerOpen(false); };
  const changerPlage = (cle, v) => {
    if (!v) return;
    const p = { ...plage, [cle]: v };
    if (p.fin < p.debut) { const t = p.debut; p.debut = p.fin; p.fin = t; }
    setPlage(p); setMode('plage');
  };

  // Filtre campagnes
  const toggleCanal = (cle) => {
    if (selCanaux.includes(cle)) setSelCanaux(selCanaux.filter(c => c !== cle));
    else {
      setSelCanaux([...selCanaux, cle]);
      setSelCamps(selCamps.filter(id => { const c = listeCamps.find(x => x.id === id); return !c || c.canal !== cle; }));
    }
  };
  const toggleCamp = (id) => {
    if (selCamps.includes(id)) setSelCamps(selCamps.filter(x => x !== id));
    else {
      setSelCamps([...selCamps, id]);
      const c = listeCamps.find(x => x.id === id);
      if (c) setSelCanaux(selCanaux.filter(k => k !== c.canal));
    }
  };
  const toutCocher = () => { setSelCanaux([]); setSelCamps([]); };
  const nbSel = selCanaux.length + selCamps.length;
  const labelCamp = nbSel === 0 ? 'Toutes les campagnes'
    : nbSel === 1
      ? (selCanaux.length === 1 ? CANAUX_META[selCanaux[0]].nom
         : ((listeCamps.find(c => c.id === selCamps[0]) || {}).nom || '1 campagne'))
      : `${nbSel} sélections`;
  const aujourdHui = () => {
    const t = new Date();
    setMode('jour');
    setSel({ year: t.getFullYear(), month: t.getMonth(), day: t.getDate() });
    setPickerOpen(false);
  };

  const ch = loading ? '…' : '—'; // placeholder chargement / absence

  // Jauge budget : uniquement en vue mois, si un budget est configuré
  const jaugePct = (budgetMensuel && kpi)
    ? Math.min(100, Math.round((kpi.depenses / budgetMensuel) * 100))
    : null;

  const pointsEvo = d ? agregerEvolution(d.evolution, vueEvo) : [];
  const tunnel = d ? d.tunnel : null;

  return (
    <div className="dbmkt">
      <style>{CSS}</style>

      {/* ============ FILTRES ============ */}
      <div className="filtres" ref={pickerRef}>
        <button className="btn" onClick={aujourdHui}>Aujourd'hui</button>
        <button className="btn periode" onClick={() => { setPickYear(sel.year); setPickerOpen(!pickerOpen); setCampOpen(false); }}>
          <IcoCal /> {labelPeriode} <IcoChevron />
        </button>
        <button className="btn periode" onClick={() => { setCampOpen(!campOpen); setPickerOpen(false); }}>
          <IcoEntonnoir /> {labelCamp} <IcoChevron />
        </button>
        {pickerOpen && (
          <div className="picker" style={{ right: 0 }}>
            <div className="onglets">
              {[['annee', 'Année'], ['mois', 'Mois'], ['jours', 'Jours']].map(([k, l]) => (
                <button key={k} className={pickerTab === k ? 'on' : ''} onClick={() => setPickerTab(k)}>{l}</button>
              ))}
            </div>
            {pickerTab === 'annee' && (
              <div className="annees">
                {[now.getFullYear(), now.getFullYear() - 1, now.getFullYear() - 2].map(a => (
                  <button key={a} className={mode === 'annee' && sel.year === a ? 'on' : ''} onClick={() => choisirAnnee(a)}>Année {a}</button>
                ))}
              </div>
            )}
            {pickerTab === 'mois' && (
              <>
                <div className="an">
                  <button onClick={() => setPickYear(pickYear - 1)}>‹</button>
                  <b>{pickYear}</b>
                  <button onClick={() => setPickYear(pickYear + 1)}>›</button>
                </div>
                <div className="grille">
                  {MOIS_COURTS.map((m, i) => (
                    <button key={m}
                      className={(mode === 'mois' || mode === 'multimois') && sel.year === pickYear && moisSel.includes(i) ? 'on' : ''}
                      onClick={() => toggleMois(i)}>
                      {m.charAt(0).toUpperCase() + m.slice(1)}
                    </button>
                  ))}
                </div>
                <div className="aide">Clique sur un ou plusieurs mois.</div>
              </>
            )}
            {pickerTab === 'jours' && (
              <div className="dates">
                <div><label>Du</label><input type="date" value={plage.debut} onChange={e => changerPlage('debut', e.target.value)} /></div>
                <div><label>Au</label><input type="date" value={plage.fin} onChange={e => changerPlage('fin', e.target.value)} /></div>
              </div>
            )}
          </div>
        )}
        {campOpen && (
          <div className="camps">
            <label className="ligne toutes">
              <input type="checkbox" checked={nbSel === 0} onChange={toutCocher} />
              <span className="nomc">Toutes les campagnes</span>
            </label>
            <div className="sep" />
            {ORDRE_CANAUX.map(cle => {
              const camps = listeCamps.filter(c => c.canal === cle);
              if (camps.length === 0 && !['google', 'meta', 'tiktok'].includes(cle)) return null;
              return (
                <React.Fragment key={cle}>
                  <label className="ligne canal-t">
                    <input type="checkbox" checked={selCanaux.includes(cle)} onChange={() => toggleCanal(cle)} />
                    <span className="pointc" style={{ background: CANAUX_META[cle].couleur }} />
                    <span className="nomc">{CANAUX_META[cle].nom}</span>
                  </label>
                  {camps.map(c => (
                    <label className="ligne enfant" key={c.id}>
                      <input type="checkbox" checked={selCamps.includes(c.id)} onChange={() => toggleCamp(c.id)} />
                      <span className="nomc" title={c.nom}>{c.nom}</span>
                    </label>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>

      {/* ============ KPI ============ */}
      <div className="kpis">
        <KpiCard ico={<IcoCarte />} icoBg="#E7EDFF" name="Dépenses"
          val={kpi ? fmtEuro(kpi.depenses) : ch}
          valSuffix={jaugePct != null ? '/ ' + fmtEuro(budgetMensuel) : null}
          deltaPct={deltas.depenses} metric="depenses"
          jauge={jaugePct} extra={jaugePct != null ? jaugePct + ' % consommé' : null}
          sparkColor="#3B82F6" sparkSeed={1} />
        <KpiCard ico={<IcoUsers />} icoBg="#E7EDFF" name="Leads"
          val={kpi ? fmtNum(kpi.leads) : ch}
          deltaPct={deltas.leads} metric="leads" sparkColor="#8B5CF6" sparkSeed={2} />
        <KpiCard ico={<IcoLosange />} icoBg="#F1EAFF" name="CPL"
          val={kpi ? fmtEuro(kpi.cpl) : ch}
          deltaPct={deltas.cpl} metric="cpl" sparkColor="#10B981" sparkSeed={3} />
        <KpiCard ico={<IcoUsers />} icoBg="#E7EDFF" name="Clients installés"
          val={kpi ? fmtNum(kpi.installs) : ch}
          deltaPct={deltas.installs} metric="installs" sparkColor="#F97316" sparkSeed={4} />
        <KpiCard ico={<IcoCible />} icoBg="#F1EAFF" name="CAC"
          val={kpi ? fmtEuro(kpi.cac) : ch}
          deltaPct={deltas.cac} metric="cac" sparkColor="#8B5CF6" sparkSeed={5} />
        <KpiCard ico={<IcoBarres />} icoBg="#E7EDFF" name="CA généré"
          val={kpi ? fmtEuro(kpi.ca) : ch}
          deltaPct={deltas.ca} metric="ca"
          extra={kpi && kpi.roas != null ? 'ROAS\u00A0\u00A0' + fmtRoas(kpi.roas) : null}
          sparkColor="#3B82F6" sparkSeed={6} />
      </div>

      {erreur && <div className="card section vide">Impossible de charger les données — réessaie ou vérifie le backend.</div>}

      {/* ============ PERFORMANCE PAR CANAL ============ */}
      <div className="card section">
        <div className="sec-head">
          <span className="ico" style={{ background: '#E7EDFF' }}><IcoBarres s={15} /></span>
          <h2>Performance par canal</h2>
          <div className="spacer" />
          <span className="tag">{tagPeriode}</span>
        </div>
        {d ? (
          <table>
            <thead><tr>
              <th>Canal</th><th>Dépenses</th><th>Leads</th><th>CPL</th><th>Clients installés</th><th>CAC</th><th>CA</th><th>ROAS</th>
            </tr></thead>
            <tbody>
              {d.canaux.map(c => (
                <tr key={c.canal}>
                  <td><span className="canal"><CanalLogo nom={c.canal} />{c.canal}</span></td>
                  <td>{fmtEuro(c.depenses)}</td>
                  <td>{fmtNum(c.leads)}</td>
                  <td className={c.cpl == null ? 'muted' : ''}>{fmtEuro(c.cpl)}</td>
                  <td>{fmtNum(c.installs)}</td>
                  <td className={c.cac == null ? 'muted' : ''}>{fmtEuro(c.cac)}</td>
                  <td>{fmtEuro(c.ca)}</td>
                  <td className={c.roas == null ? 'muted' : ''}>{fmtRoasTab(c.roas)}</td>
                </tr>
              ))}
              <tr className="total">
                <td>Total</td>
                <td>{fmtEuro(d.canal_total.depenses)}</td>
                <td>{fmtNum(d.canal_total.leads)}</td>
                <td>{fmtEuro(d.canal_total.cpl)}</td>
                <td>{fmtNum(d.canal_total.installs)}</td>
                <td>{fmtEuro(d.canal_total.cac)}</td>
                <td>{fmtEuro(d.canal_total.ca)}</td>
                <td>{fmtRoasTab(d.canal_total.roas)}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <div className="vide">{loading ? 'Chargement…' : 'Aucune donnée'}</div>
        )}
      </div>

      {/* ============ TUNNEL(S) DE CONVERSION ============ */}
      <div className="card section">
        <div className="sec-head">
          <span className="ico" style={{ background: '#E7EDFF' }}><IcoEntonnoir /></span>
          <h2>{d && d.tunnels && d.tunnels.length > 1 ? `Tunnels de conversion — comparaison (${d.tunnels.length})` : 'Tunnel de conversion'}</h2>
          <div className="spacer" />
          {nbSel > 0 ? <span className="tag">{tagPeriode}</span> : null}
        </div>
        {d && d.tunnels && d.tunnels.length > 0 ? (
          d.tunnels.map((t, idx) => {
            let canalT = t.canal;
            if ((!canalT || canalT === 'autre') && t.id) {
              const c = listeCamps.find(x => x.id === String(t.id));
              if (c) canalT = c.canal;
            }
            const cm = CANAUX_META[canalT] || CANAUX_META.autre;
            const pct = (a, b) => (b > 0 ? Math.round(a / b * 1000) / 10 : null);
            return (
              <div className="tunnel-bloc" key={idx}>
                <div className="tunnel-head">
                  <span className="badge-canal" style={{ background: cm.couleur }}>{cm.nom}</span>
                  <span className="titre-t" title={t.titre}>{t.titre}</span>
                  <span className="dep-t">{t.depenses > 0 ? fmtEuro(t.depenses) + ' dépensés' : ''}</span>
                </div>
                <TunnelLigne leads={t.leads} devis_envoyes={t.devis_envoyes} devis_signes={t.devis_signes}
                  installs={t.installs} p1={pct(t.devis_envoyes, t.leads)} p2={pct(t.devis_signes, t.devis_envoyes)}
                  p3={pct(t.installs, t.devis_signes)} taux_global={pct(t.installs, t.leads)} ch={ch} />
              </div>
            );
          })
        ) : (
        <div className="tunnel">
          <div className="etape" style={{ background: '#EAF1FD' }}>
            <span className="ei"><IcoUsers s={17} /></span>
            <div><div className="lbl" style={{ color: '#2563EB' }}>Leads</div><div className="num">{tunnel ? fmtNum(tunnel.leads) : ch}</div></div>
          </div>
          <div className="fleche"><span className="pct">{tunnel ? fmtPct(tunnel.p1) : '—'}</span><IcoFleche /></div>
          <div className="etape" style={{ background: '#F2EDFD' }}>
            <span className="ei"><IcoDoc c="#7C3AED" /></span>
            <div><div className="lbl" style={{ color: '#7C3AED' }}>Devis envoyés</div><div className="num">{tunnel ? fmtNum(tunnel.devis_envoyes) : ch}</div></div>
          </div>
          <div className="fleche"><span className="pct">{tunnel ? fmtPct(tunnel.p2) : '—'}</span><IcoFleche /></div>
          <div className="etape" style={{ background: '#E5F8EE' }}>
            <span className="ei"><IcoDocOk c="#10B981" /></span>
            <div><div className="lbl" style={{ color: '#0E9F6E' }}>Devis signés</div><div className="num">{tunnel ? fmtNum(tunnel.devis_signes) : ch}</div></div>
          </div>
          <div className="fleche"><span className="pct">{tunnel ? fmtPct(tunnel.p3) : '—'}</span><IcoFleche /></div>
          <div className="etape" style={{ background: '#FDEFE3' }}>
            <span className="ei"><IcoUsers c="#F97316" s={17} /></span>
            <div><div className="lbl" style={{ color: '#F97316' }}>Clients installés</div><div className="num">{tunnel ? fmtNum(tunnel.installs) : ch}</div></div>
          </div>
          <div className="sep" />
          <div className="global">
            <IcoCourbe s={26} />
            <div>
              <div className="txt1">Taux d'installation global</div>
              <div className="txt2">{tunnel ? fmtPct(tunnel.taux_global) : ch}</div>
              <div className="txt3">{tunnel ? `(${tunnel.installs} / ${tunnel.leads} leads)` : ''}</div>
            </div>
          </div>
        </div>
        )}
      </div>

      {/* ============ TOP CAMPAGNES ============ */}
      <div className="card section">
        <div className="sec-head">
          <span className="ico" style={{ background: '#E7EDFF' }}><IcoTrophee /></span>
          <h2>Top campagnes</h2>
          <div className="spacer" />
          <span className="tag">{tagPeriode}</span>
        </div>
        {d && d.top_campagnes && d.top_campagnes.length > 0 ? (
          <table>
            <thead><tr>
              <th>Campagne</th><th>Canal</th><th>Dépenses</th><th>Leads</th><th>CPL</th><th>Installés</th><th>CAC</th><th>CA généré</th><th>ROAS</th>
            </tr></thead>
            <tbody>
              {d.top_campagnes.map(c => (
                <tr key={c.nom}>
                  <td>{c.nom}</td><td>{c.canal}</td>
                  <td className={c.depenses == null ? 'muted' : ''}>{fmtEuro(c.depenses)}</td>
                  <td>{fmtNum(c.leads)}</td>
                  <td className={c.cpl == null ? 'muted' : ''}>{fmtEuro(c.cpl)}</td>
                  <td>{fmtNum(c.installs)}</td>
                  <td className={c.cac == null ? 'muted' : ''}>{fmtEuro(c.cac)}</td>
                  <td>{fmtEuro(c.ca)}</td>
                  <td className={c.roas == null ? 'muted' : ''}>{fmtRoasTab(c.roas)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="vide">{loading ? 'Chargement…' : 'Aucune campagne sur cette période'}</div>
        )}
      </div>

      {/* ============ ÉVOLUTION DES PERFORMANCES ============ */}
      <div className="card section">
        <div className="sec-head">
          <span className="ico" style={{ background: '#E7EDFF' }}><IcoCourbe /></span>
          <h2>Évolution des performances</h2>
          <div className="spacer" />
          <div className="evo-vues">
            {['jour', 'semaine', 'mois'].map(v => (
              <button key={v} className={vueEvo === v ? 'on' : ''} onClick={() => setVueEvo(v)}>
                {v.charAt(0).toUpperCase() + v.slice(1)}
              </button>
            ))}
          </div>
        </div>
        <div className="evo-controls">
          {EVO_SERIES.map(s => (
            <span key={s.key} className={'chk' + (actives[s.key] ? '' : ' off')}
              onClick={() => setActives({ ...actives, [s.key]: !actives[s.key] })}>
              <span className="box" style={{ background: s.color }}><Coche /></span>
              <span style={{ color: s.color }}>{s.label}</span>
            </span>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', fontWeight: 600, color: '#64748B', padding: '0 4px 4px' }}>
          <span>Leads / Clients</span><span>Montants (€)</span>
        </div>
        {loading ? <div className="vide">Chargement…</div> : <EvolutionChart points={pointsEvo} actives={actives} />}
      </div>

    </div>
  );
};

export default DashboardMarketing;
